import * as React from 'react';

export const FormContext = React.createContext(undefined);

export const PatcherContext = React.createContext(undefined);
